import type { FC } from 'react';
import { ClipLoader } from 'react-spinners';

export const CartLoader: FC = () => (
  <div className="pje-App-mainLoader" data-testid="main-loader">
    {/* TODO: Export Project Service Design Tokens & import 'colorRed' here */}
    <ClipLoader color="#FA3C00" speedMultiplier={0.65} />
    <p>Loading your cart...</p>
  </div>
);
